import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/1dde86ed/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`General guidance`}</h2>
    <p>{`The accordion component delivers large amounts of content in a small space through progressive disclosure. That is, the user gets key details about the underlying content and can choose to expand that content within the constraints of the accordion. Accordions work especially well on mobile interfaces or whenever vertical space is at a premium.`}</p>
    <p>{`Avoid “nested” accordions—that is, collapsible content within collapsible content. This type of pattern goes against UX best practices.`}</p>
    <p>{`The Carbon accordion allows for multiple sections to be expanded simultaneously.`}</p>
    <p>{`A chevron is used to indicate the “expand/collapse” action, though the entire header area is clickable for the same action.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70.27863777089783%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAABG0lEQVQ4y51UB27EQAj0//9oucu998ppULBIvLmcgjQCVsuYtrau6yIAIvZ/IPEWfYkcav9d8M840Za+lCQJRVFEcRzTOzFldmeonbIsmSxNU6rrmqqqYoidZRn1fc/3z/PkmH3ffyec55mmaaJxHGkYBtYgaNuW1nWlbdtuAiE8juNJKAfIBGUjk6IoKM9z1oAQgkCLkVAckLmuS0EQkO/75DgOa8/z2LZtm230GZWY+vqNEP0DoRBAwweEGAjDkNvx55S7ruMyBSgHQL8A9E+XbNxD7SzLcg8GGsCZAH1EZjIYPRwjIVZD1gb9FIiPoaEKDEcIxTYSYlWwIghqmoY1fFkdKVdn9thD07P79JXouMeUP/05mD6g5QUX6kcEecZqQwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "accordion example",
            "title": "accordion example",
            "src": "/static/609afc8d39c70f5e60c1557c46d0b11a/3cbba/accordion-usage-1.png",
            "srcSet": ["/static/609afc8d39c70f5e60c1557c46d0b11a/7fc1e/accordion-usage-1.png 288w", "/static/609afc8d39c70f5e60c1557c46d0b11a/a5df1/accordion-usage-1.png 576w", "/static/609afc8d39c70f5e60c1557c46d0b11a/3cbba/accordion-usage-1.png 1152w", "/static/609afc8d39c70f5e60c1557c46d0b11a/3c3d2/accordion-usage-1.png 1292w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      